import { ReactComponent as BTCIcon } from 'assets/icons/BitcoinIcon.svg';
import { ReactComponent as CardIcon } from 'assets/icons/CardIcon.svg';
import { ReactComponent as FiatIcon } from 'assets/icons/FiatIcon.svg';
import { ReactComponent as KlarnaIcon } from 'assets/icons/KlarnaIcon.svg';
import { PaymentOption } from 'types/payment.types';

export const SECOND_IN_MILLISECONDS = 1000;
export const USER_ACCESS_KEY = 'accessToken';
export const USER_REFRESH_KEY = 'refreshToken';
export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_ADMIN_PORT = '3001';
export const BTC_DEFAULT_PRICE = 100000;
export const VIA_BTC_IP = '74.177.204.129';
export const USER_META_STORAGE_KEY = 'USER_META_STORAGE_KEY';

export const PAYMENT_OPTIONS: PaymentOption[] = [
  { value: 'crypto', label: 'Pay with Crypto', Icon: BTCIcon },
  { value: 'fiat', label: 'Pay with Fiat', Icon: FiatIcon },
  { value: 'klarna', label: 'Pay with Klarna', Icon: KlarnaIcon },
  { value: 'stripe', label: 'Pay with Card (Stripe)', Icon: CardIcon },
];
